import type { TransformBookingToCheckoutData } from '@/scopes/checkout/domain/types'
import { GroupStatus } from '@/domain/groups/types'

export interface TransformBookingToCheckoutDataMapper {
  map: (data?: GroupStatus) => TransformBookingToCheckoutData
}

export function createTransformBookingToCheckoutMapper(): TransformBookingToCheckoutDataMapper {
  const map = (data?: GroupStatus) => {
    if (!data) {
      return {}
    }
    return {
      hasRoomSelection: data.roomSelectionIsEnabled ?? false,
      roomsHavePinCode: data.pinCodeIsRequiredForRoomSelection ?? false,
    }
  }

  return {
    map,
  }
}
